<template>
  <v-container grid-list-md text-xs-center >
    <v-layout row wrap >
      <v-flex xs4>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Type Picker</h3>
              <div>Walking, Biking, Driving</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
            flat
            color="orange"
            @click.native="travelTypePickerWalk">
            >
            <v-icon left>directions_walk</v-icon>
            Walk
            </v-btn>
            <v-btn
            flat
            color="orange"
            @click.native="travelTypePickerBike">
            >
            <v-icon left>directions_bike</v-icon>
            Bike
            </v-btn>
            <v-btn
            flat
            color="orange"
            @click.native="travelTypePickerCar">
            >
            <v-icon left>directions_car</v-icon>
            Car
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  methods: {
    travelTypePickerWalk () {
      this.$store.dispatch('pickType', 'walk')
      this.$router.push('/')
    },
    travelTypePickerBike () {
      this.$store.dispatch('pickType', 'bike')
      this.$router.push('/')
    },
    travelTypePickerCar () {
      this.$store.dispatch('pickType', 'car')
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/toolBox/typePicker.vue